(function () {
  function getRootDocument() {
    // If we're in the block editor top window, target the iframe document
    const iframe = document.querySelector('.block-editor-iframe__frame, iframe[name="editor-canvas"]');
    if (iframe && iframe.contentDocument) {
      return iframe.contentDocument;
    }

    // Frontend or already inside iframe
    return document;
  }

  // Height normalizer
  function updateSwiperHeight(swiper) {
    const max = Math.max(...swiper.slides.map((s) => s.offsetHeight));
    swiper.el.style.setProperty("--swiper-max-height", max + "px");
  }

  function initEventsBlock() {
    const rootDoc = getRootDocument();

    const swipers = rootDoc.querySelectorAll(".swiper-events");

    swipers.forEach((swiperEl) => {
      // Prevent double init
      if (swiperEl.dataset.swiperInitialized === "1") return;

      swiperEl.dataset.swiperInitialized = "1";

      const id = swiperEl.id;
      const section = swiperEl.closest("section");

      const nextBtn = section?.querySelector(`.swiper-button-next[data-target="${id}"]`);
      const prevBtn = section?.querySelector(`.swiper-button-prev[data-target="${id}"]`);

      const pagination = section?.querySelector(`.swiper-pagination`);

      if (typeof Swiper === "undefined") return;

      new Swiper(swiperEl, {
        loop: true,
        centeredSlides: true,
        centeredSlidesBounds: true,
        slidesPerView: 1.1,
        spaceBetween: 16,
        navigation: {
          nextEl: nextBtn,
          prevEl: prevBtn,
        },
        pagination: {
          el: pagination,
          clickable: true,
        },
        on: {
          init(swiper) {
            updateSwiperHeight(swiper);
          },
          resize(swiper) {
            updateSwiperHeight(swiper);
          },
          slideChange(swiper) {
            updateSwiperHeight(swiper);
          },
        },
        breakpoints: {
          380: { slidesPerView: 1.2 },
          700: { slidesPerView: 3, loop: false },
          // 1000: { slidesPerView: 3 },
          // 1500: { slidesPerView: 3 },
        },
      });
    });

    // Filtering
    // Filtering
    const buttons = rootDoc.querySelectorAll(".btn-filter");

    // Helper: run filter animation for a specific section/block
    function runFilter(section, filter) {
      const events = section.querySelector(".events");
      if (!events) return;

      const items = events.querySelectorAll(".col");
      const currentVisible = Array.from(events.querySelectorAll(".col:not(.hidden)"));

      if (typeof gsap === "undefined") {
        // Fallback without animation
        items.forEach((item) => {
          const groups = (item.dataset.groups || "").split(" ");
          const shouldShow = filter === "all" || groups.includes(filter);
          item.classList.toggle("hidden", !shouldShow);
        });
        return;
      }

      gsap.to(currentVisible, {
        opacity: 0,
        y: 30,
        duration: 0.4,
        stagger: 0.05,
        ease: "power2.in",
        onComplete: () => {
          items.forEach((item) => {
            const groups = (item.dataset.groups || "").split(" ");
            const shouldShow = filter === "all" || groups.includes(filter);
            item.classList.toggle("hidden", !shouldShow);
          });

          const newVisible = Array.from(events.querySelectorAll(".col:not(.hidden)"));

          gsap.fromTo(
            newVisible,
            { opacity: 0, y: 30 },
            {
              opacity: 1,
              y: 0,
              duration: 0.8,
              stagger: 0.12,
              ease: "power2.out",
            }
          );
        },
      });
    }

    // Initialize buttons
    buttons.forEach((btn) => {
      if (btn.dataset.filterInit === "1") return;
      btn.dataset.filterInit = "1";

      btn.addEventListener("click", () => {
        const section = btn.closest("section");
        if (!section) return;

        // Only affect buttons in THIS section
        const sectionButtons = section.querySelectorAll(".btn-filter");
        sectionButtons.forEach((b) => b.classList.remove("active"));
        btn.classList.add("active");

        const filter = btn.dataset.group;
        runFilter(section, filter);
      });
    });

    // Apply filter on page load if a button is already active in a section
    const sections = rootDoc.querySelectorAll("section");
    sections.forEach((section) => {
      const activeBtn = section.querySelector(".btn-filter.active");
      if (activeBtn) {
        runFilter(section, activeBtn.dataset.group);
      }
    });
  }

  // FRONTEND: run when DOM is ready
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initEventsBlock);
  } else {
    initEventsBlock();
  }

  // EDITOR: run when block editor iframe is ready
  if (window.wp && wp.domReady) {
    wp.domReady(initEventsBlock);
  }

  // EDITOR: detect when ACF block HTML appears
  const observer = new MutationObserver(() => initEventsBlock());
  observer.observe(document.body, { childList: true, subtree: true });
})();
